export default "__VITE_ASSET__BTh6rfvv__"